<template>
  <div v-loading="authLoading" class="real-name-auth-gate">
    <slot v-if="authChecked && authenticated" :authenticated="authenticated"></slot>
    <real-name-auth v-else-if="authChecked" embedded @authenticated="handleAuthenticated"></real-name-auth>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getRealNameAuthStatus } from '@/api/promotionManage'
import RealNameAuth from '../realNameAuth'

// 推广管理页面内实名认证门禁；关闭时直接放行业务内容。
const ENABLE_REAL_NAME_AUTH = true

export default {
  name: 'promotionRealNameAuthGate',
  components: {
    RealNameAuth
  },
  data () {
    return {
      authLoading: false,
      authChecked: false,
      authenticated: false,
      hasCheckedOnce: false
    }
  },
  computed: {
    ...mapState('user', {
      userInfo: state => state.userInfo
    }),
    mobile () {
      return this.userInfo.mobile || ''
    }
  },
  created () {
    this.initAuth()
  },
  activated () {
    if (this.hasCheckedOnce) {
      this.initAuth()
    }
  },
  methods: {
    initAuth () {
      if (!ENABLE_REAL_NAME_AUTH) {
        this.authenticated = true
        this.authChecked = true
        this.hasCheckedOnce = true
        this.$nextTick(() => {
          this.$emit('authenticated')
        })
        return
      }
      this.checkAuth()
    },
    isSuccess (code) {
      return code === 0 || code === 200
    },
    isAuthenticated (result) {
      if (result === true || result === 1) return true
      return !!(result && (
        result.authenticated ||
        result.isRealNameAuth ||
        result.realNameAuth ||
        result.verifyStatus === 1 ||
        result.status === 1
      ))
    },
    async checkAuth () {
      this.authLoading = true
      try {
        const { code, result } = await getRealNameAuthStatus({ mobile: this.mobile })
        this.authenticated = this.isSuccess(code) && this.isAuthenticated(result)
        if (this.authenticated) {
          this.$nextTick(() => {
            this.$emit('authenticated')
          })
        }
      } catch (error) {
        this.authenticated = false
      } finally {
        this.authChecked = true
        this.hasCheckedOnce = true
        this.authLoading = false
      }
    },
    handleAuthenticated () {
      this.authenticated = true
      this.authChecked = true
      this.$nextTick(() => {
        this.$emit('authenticated')
      })
    }
  }
}
</script>

<style lang="less" scoped>
.real-name-auth-gate {
  min-height: 360px;
}
</style>
